import React, { useEffect, useState } from 'react';
import { apiGet } from '../../lib/api';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import { AlertCircle } from 'lucide-react';

export default function Reports() {
  const [revenue, setRevenue] = useState([]);
  const [outstanding, setOutstanding] = useState([]);

  useEffect(() => {
    apiGet('/merchant/reports/revenue').then(r => setRevenue(r.data || [])).catch(() => {});
    apiGet('/merchant/reports/outstanding').then(r => setOutstanding(r.data || [])).catch(() => {});
  }, []);

  return (
    <div className="space-y-6" data-testid="reports-page">
      <h1 className="font-heading font-extrabold text-3xl text-rozops-navy tracking-tight">Reports</h1>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-soft p-6">
        <div className="text-xs uppercase tracking-widest font-bold text-rozops-text-muted">Monthly revenue</div>
        <div className="h-64 mt-4">
          {revenue.length === 0 ? (
            <div className="h-full grid place-items-center text-rozops-text-muted text-sm">No data yet — generate invoices to see revenue.</div>
          ) : (
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={revenue}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
                <XAxis dataKey="month" stroke="#5F6B7A" />
                <YAxis stroke="#5F6B7A" />
                <Tooltip />
                <Bar dataKey="total" fill="#5B21F4" radius={[8, 8, 0, 0]} />
                <Bar dataKey="paid" fill="#10B981" radius={[8, 8, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          )}
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-soft p-6">
        <div className="flex items-center gap-2 text-rozops-text-muted mb-3"><AlertCircle className="w-4 h-4" /><span className="text-xs uppercase tracking-widest font-bold">Outstanding payments</span></div>
        {outstanding.length === 0 && <div className="py-6 text-center text-rozops-text-muted text-sm">No outstanding invoices. 🎉</div>}
        {outstanding.map(o => (
          <div key={o.id} className="flex justify-between items-center py-2 border-b border-gray-50 last:border-0">
            <div>
              <div className="font-semibold text-rozops-text">{o.customer?.full_name}</div>
              <div className="text-xs text-rozops-text-muted">{o.invoice_number} · due {o.due_date}</div>
            </div>
            <div className="text-red-500 font-heading font-bold">₹{Number(o.due_amount).toFixed(2)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
